import React from 'react';

import { observer } from 'mobx-react-lite';

import { Button } from 'src/domains/common/components/button/button';

import { useCommon } from 'src/AppState/Common';
import { cn } from 'src/domains/common/components/utils';

import { CSVUploadState } from './CSVUploadV2.state';

export const CSVUploadV2 = observer(() => {
    const common = useCommon();
    const [state] = React.useState(() => new CSVUploadState(common));

    const isFileEmpty = state.fileName === '';

    return (
        <div className='max-w-[33rem] flex flex-col gap-4'>
            <span className='text-base font-semibold my-2'>CSV Upload</span>

            <label
                className={cn(
                    'border-2 border-dashed h-20 flex border-foreground/50 justify-center items-center text-foreground text-sm',
                    {
                        'text-muted-foreground border-border': isFileEmpty,
                        'border-destructive': state.errors.length > 0,
                    }
                )}
                data-test='upload-file'
                onDrop={state.onFileDrop}
                onDragOver={(e) => e.preventDefault()}
            >
                {isFileEmpty ? 'Drag & Drop to upload CSV' : state.fileName}
            </label>

            <div className='flex gap-3 w-full'>
                <Button
                    variant='secondary'
                    className='w-1/2'
                    onClick={() => state.fileInputRef.ref?.click()}
                >
                    Select CSV
                </Button>
                <Button
                    className='w-1/2'
                    onClick={state.upload}
                    type='button'
                    disabled={state.file === null}
                    isLoading={state.isLoading}
                >
                    Upload CSV
                </Button>
                <input
                    ref={state.setFileRef}
                    type='file'
                    accept='.csv,.xlsx'
                    onChange={state.onSelectFile}
                    className='absolute invisible'
                />
            </div>
        </div>
    );
});
